<template>
  <div
    v-if="galleryItems.length"
    class="media-gallery"
  >
    <div class="media-gallery__container">
      <UiMediaGalleryMain
        :name="props.name"
        class="media-gallery__main"
      />

      <UiMediaGalleryNavigation
        v-if="galleryOptions.navigation"
        :name="props.name"
        class="media-gallery__navigation"
      >
        <template #gallery-prev-icon>
          <slot name="gallery-prev-icon" />
        </template>

        <template #gallery-next-icon>
          <slot name="gallery-next-icon" />
        </template>
      </UiMediaGalleryNavigation>

      <UiMediaGalleryThumbs
        v-if="galleryOptions.thumbs"
        :name="props.name"
        class="media-gallery__thumbs"
        :thumbs-direction="galleryOptions.thumbsDirection"
        :thumbs-trigger="galleryOptions.thumbsTrigger"
      >
        <template #thumbs-prev-icon>
          <slot name="thumbs-prev-icon" />
        </template>

        <template #thumbs-next-icon>
          <slot name="thumbs-next-icon" />
        </template>
      </UiMediaGalleryThumbs>

      <UiMediaGalleryDots
        v-if="galleryOptions.dots"
        :name="props.name"
        class="media-gallery__dots"
      />

      <UiMediaGalleryXofY
        v-if="galleryOptions.XofY"
        :name="props.name"
        class="media-gallery__x-of-y"
      />

      <slot />
    </div>

    <UiMediaGalleryFullscreen
      v-if="galleryOptions.fullscreen"
      :name="props.name"
    />
  </div>
</template>

<script lang="ts" setup>
import type { GalleryOptions } from '~layers/app/composables/useUiMediaGallery.ts'

const props = withDefaults(defineProps<
  {
    name?: string
    options: GalleryOptions
  }
>(), {
  name: () => 'media-gallery',
})

const { galleryItems, galleryOptions } = useUiMediaGallery(props.name, props.options)

const { close } = useUiDialog(props.name)

onUnmounted(() => {
  close()
})
</script>

<style>
@import url("~layers/app/components/Ui/MediaGallery/index.css");
</style>
